<template>
<div class="grid mt-4"> 


<template v-if="!is_connected">
<div class="col-12 ">
<h4 class="text-red-500">Bu modüle bağlı bir veri modülü bulunmuyor</h4>
</div>  
</template>


<template v-else>

<div class="col-12 ">
<span class="p-float-label">
<InputText  type="text" v-model="name" class="w-full p-inputtext-sm"  @change="nameUpdated"  />
<label  class="text-primary">İsim</label>
</span>
</div>

<div class="col-12 ">
<h4 class="text-primary">Yüzdesi Alınacak Girdileri Seçin</h4>
</div>  


<div class="col-12 pb-5">
<span class="p-float-label">
<Dropdown :filter="false"  v-model="selected_input" :options="inputs" optionLabel="name"   class="w-full p-inputtext-sm" @change="inputSelected"/>
<label  class="text-primary">Bir Giriş Seçin</label>
</span>
</div>


<div class="col-12 " v-if="show_value_input">
<div class="grid">

<div class="col-10">
<span class="p-float-label">
<InputText  type="number" v-model="thevalue" class="w-full p-inputtext-sm"    />
<label  class="text-primary">İsim</label>
</span>
</div>

<div class="col-2">
<div class="flex align-items-center justify-content-end ">
<Button type="button"  icon="pi pi-check" @click="submitValue" class="p-button-primary p-button-outlined p-button-sm mr-2"   />
<Button type="button"  icon="pi pi-times" @click="cancelValue" class="p-button-danger p-button-outlined p-button-sm "  />
</div>
</div>


</div>

</div>




<div class="col-12 ">
<h4 class="text-primary">Hesaplama Girdileri</h4>
</div>
<div class="col-12 ">
<p v-for="(item,index) in $store.state.calculations.selectednode.data.output.inputs" class="mb-3 mt-1">

<template v-if="index == $store.state.calculations.selectednode.data.output.inputs.length-1">
<Tag icon="pi pi-times"   :style="'background-color:#4dc247'" :value="item.name" @click="removeItem(item.id)"></Tag>  
</template>
<template v-else>
<Tag icon="pi pi-times"   :style="'background-color:#4dc247'" :value="item.name+' -'" @click="removeItem(item.id)"></Tag> 
</template>


</p>
</div>


</template>










</div>  
</template>

<script>
export default {

  name: 'PercentageNodeData',

  data () {
    return {
      selected_input:null,
      inputs:[
      {name:"Sayı",id:"0",type:"value"}
      ],
      name:null,
      show_value_input:false,
      thevalue:0,
    }
  },
  computed:{
    is_connected()
    {
      if(this.$store.state.calculations.selectednode)
      {
        let selectednode = this.$store.state.calculations.selectednode
        if(selectednode.data && selectednode.data.output.name)
        {
          this.name = selectednode.data.output.name
        }
        
        let connections = this.$store.state.calculations.connections
        let the_connection = connections.findIndex((item)=>{return item.to == selectednode.id})
        if(the_connection!==-1)
        {
          let root_node = this.findRootNode()
          return true
        }
        return false
      }
      return false      
    },
  },
  methods:{
    submitValue()
    {
      console.log(this.inputs)
      console.log(this.$store.state.calculations.selectednode)
      let obj = {
        name:this.thevalue+ " - Değer",
        type:"value",
        id:Math.floor(Date.now() / 10),
        value:this.thevalue
      }
      let selectednode = this.$store.state.calculations.selectednode
      selectednode.data.output.inputs.push(obj)
      this.updateNodeData(selectednode)
      this.selected_input = null
    },
    cancelValue()
    {
      this.show_value_input = false
      this.thevalue = 0
      this.selected_input = null
    },
    removeItem(id)
    {
      let selectednode = this.$store.state.calculations.selectednode
      let inputs = selectednode.data.output.inputs.filter((item)=>{return item.id !== id})
      selectednode.data.output.inputs = inputs
      this.updateNodeData(selectednode)
    },
    nameUpdated()
    {
      let selectednode = this.$store.state.calculations.selectednode
      selectednode.data.output.name = this.name
      this.updateNodeData(selectednode)
    },
    inputSelected()
    {
      if(this.$store.state.calculations.selectednode.data.output.inputs.length==2)
      {

            this.showMessage("error","Yüzde türü modüllere en fazla 2 hesaplama girdisi eklenebilir","")
        this.selected_input = null
        return false
      }
      console.log(this.selected_input)
      if(this.selected_input.type=="value")
      {
        console.log("sayı")
        this.show_value_input = true
        return false
      }
      this.show_value_input = false
      let obj = {
        name:this.selected_input.name,
        input_stack_id:this.selected_input.stack_id,
        id:Math.floor(Date.now() / 10),
        type:this.selected_input.type
      }
      
      //update node data
      let selectednode = this.$store.state.calculations.selectednode
      selectednode.data.output.inputs.push(obj)
      this.updateNodeData(selectednode)
      this.selected_input = null
        //update node data
    },
    updateNodeData(selectednode)
    {
      let nodes = this.$store.state.calculations.nodes
      let ind = nodes.findIndex((item)=>{return item.id == selectednode.id})
      nodes[ind] = selectednode
      this.$store.dispatch('calculations/setNodes',nodes)
        this.$store.dispatch('calculations/setSelectedNode',selectednode)
    },
    findRootNode()
    {
      let selectednode = this.$store.state.calculations.selectednode
      let connections = this.$store.state.calculations.connections
      let nodes = this.$store.state.calculations.nodes
      let the_connection = connections.find((item)=>{return item.to == selectednode.id.toString()}) 
      if(the_connection)
      {       
        let from_node = this.findPrevNode(the_connection.from)        
        return from_node
      }
      return "no_connection"
    },
    findPrevNode(nodeId)
    {
      let connections = this.$store.state.calculations.connections
      let nodes = this.$store.state.calculations.nodes
      let node = nodes.find((item)=>{return item.id == nodeId.toString()})
      console.log("findPrevNode")
      console.log(node)
      if(node.key=="calculations")
    {         
      this.addToInputsStack(node.data.output)
    }
      //if prev node is not suppliers
      if(node.type!=="suppliers")
      {
        let the_connection = connections.find((item)=>{return item.to == nodeId.toString()})
        if(!the_connection)
        {
          return "no_connection"
        }
        let from_node = this.findPrevNode(the_connection.from) 
        
        
        return from_node
      }
      //if prev node is not suppliers

      //if prev node is suppliers
      node = this.sanitizeArray(node)
      let outputs = node.data.outputs
      let filtered = outputs.filter((item)=>{
          if(item.name.length>20)
          {
            item.name = item.name.substring(0, 120)+"..."
          }
          if(item.type=="section_points")
          {
            item.name = item.name+" - Bölüm Puanı"
            return item
          }
          if(item.type=="questionlist_points")
          {
            item.name = item.name+" - Soru Listesi Puanı"
            return item
          }
          if(item.type=="inputfield_point")
          {
            item.name = item.name+" - Soru Puanı"
            return item
          }
          if(item.type=="custom_attribute")
          {
            if(item.custom_attribute_type=="number")
            {
              item.name = item.name+" -  Özel Nitelik"
              return item
            }
          }
          if(item.type=="inputfield_submission")
          {
            if(item.column_id)
            {
              if(item.column_type=="number")
              {
                item.name = item.name+" -  Soru Verisi"
                return item
              }
            }
            else
            {
              if(item.inputfield_type=="number")
              {
                item.name = item.name+" -  Soru Verisi"
                return item
              }
            }
          }
        })
      for(let item of filtered)
      {
        this.addToInputsStack(item)
      }
      return node
      //if prev node is suppliers

    },
    addToInputsStack(input)
    {
      
      this.inputs.push(input)
    }
  },
}
</script>

<style lang="css" scoped>
</style>